import { formatDateFilterToken } from 'utils/dateUtils';

export type SubmissionDateRange = [string | null, string | null];

export const hasCompleteDateRange = (
  startDate: string | null | undefined,
  endDate: string | null | undefined
) => !!startDate && !!endDate;

export const hasEmptyDateRange = (
  startDate: string | null | undefined,
  endDate: string | null | undefined
) => !startDate && !endDate;

export const hasPartialDateRange = (
  startDate: string | null | undefined,
  endDate: string | null | undefined
) =>
  !hasEmptyDateRange(startDate, endDate) &&
  !hasCompleteDateRange(startDate, endDate);

export const hasCompleteSelectedDateRange = (dateRange: SubmissionDateRange) =>
  hasCompleteDateRange(dateRange[0], dateRange[1]);

export const hasEmptySelectedDateRange = (dateRange: SubmissionDateRange) =>
  hasEmptyDateRange(dateRange[0], dateRange[1]);

export const hasPartialSelectedDateRange = (dateRange: SubmissionDateRange) =>
  hasPartialDateRange(dateRange[0], dateRange[1]);

export const formatSelectedDateRange = (
  dateRange: SubmissionDateRange
): { startDate?: string; endDate?: string } => {
  if (!hasCompleteSelectedDateRange(dateRange)) {
    return {};
  }

  return {
    startDate: formatDateFilterToken(dateRange[0]),
    endDate: formatDateFilterToken(dateRange[1]),
  };
};
